import { InFileError } from "./InFileError";

export class DhConfigError extends InFileError {
    customer = "";
    fileName = "";
}
